// react library imports
import { useRef, useState, useEffect } from 'react';

// style imports
import "../Input/Input.css";
import './TextDescriptionField.css';

const TextDescriptionField = ({label, id, onChange, initialValue, maxLength, readOnly}) => {
  // set state of value
  const [value, setValue]=useState("")
  const inputRef = useRef(null);

  useEffect(()=>{
    setValue(initialValue)
  }, [initialValue])

  // handle input focus
  const handleEditClick = () => {
    inputRef.current.focus();
  };

  // handle onchange event
  const handleOnChange=(e)=>{
    setValue(e.target.value)
    if (onChange) {
      onChange(e.target.value)
    }
  }
  
  return (
    <div className="form-input form-textarea">
      <textarea value={value} onChange={handleOnChange} maxLength={maxLength}
      ref={inputRef} placeholder={label} readOnly={readOnly} id={id}></textarea>
      <label htmlFor={label} onClick={handleEditClick}>{label}</label>
    </div>
  )
}

export default TextDescriptionField